import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { InventoryManagerFormAtomProps } from "../InventoryManagerForm.types";

import styles from "../InventoryManagerForm.module.scss";

const NameFields = ({ control }: InventoryManagerFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.form_twoInputsBlock}>
      <Controller
        control={control}
        name="firstname"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("First Name")}
            placeholder={t("Enter First Name")}
            errorMessage={error?.message}
            data-testid="inventory-manager--firstName"
          />
        )}
      />

      <Controller
        control={control}
        name="lastname"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={t("Last Name")}
            placeholder={t("Enter Last Name")}
            errorMessage={error?.message}
            data-testid="inventory-manager--lastName"
          />
        )}
      />
    </div>
  );
};

export default NameFields;
